<div class="notifications-trigger position-relative">
  <button class="bell-btn position-relative" (click)="onBellClick($event)" type="button">
    <img src="assets/images/icons/notifaction.svg" alt="Notifications" width="20" height="22" />
    @if (hasUnviewed()) {
      <span class="unviewed-dot"></span>
    }
  </button>

  @if (isOpen()) {
    <div class="notifications-panel" (click)="onPanelClick($event)">
      <div class="panel-header d-flex align-items-center justify-content-between">
        <span class="fw-medium text-sm">Notifications</span>
        @if (!loading() && notifications().length > 0) {
          <button class="mark-all-btn" type="button" (click)="onNavigateToNotificationsPage()">
            See all
          </button>
        }
      </div>

      @if (loading()) {
        <div class="notifications-list">
          @for (item of [].constructor(5); track $index) {
            <div class="notification-item d-flex align-items-start gap-3">
              <p-skeleton shape="circle" size="40px" styleClass="flex-shrink-0" />
              <div class="notification-body flex-grow-1 d-flex flex-column gap-2">
                <p-skeleton width="220px" height="14px" />
                <p-skeleton width="100px" height="12px" />
              </div>
            </div>
          }
        </div>
      }

      @if (!loading() && notifications().length === 0) {
        <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-3">
          <img src="assets/images/icons/no-notifications.svg" alt="No notifications" width="100" />
          <p class="mb-0">No Notifications yet</p>
        </div>
      }

      @if (!loading() && notifications().length > 0) {
        <div class="notifications-list">
          @for (notification of notifications(); track notification.id) {
            <div
              class="notification-item d-flex align-items-start gap-3"
              [class.unread]="!notification.is_read"
              (click)="onItemClick(notification)"
            >
              <div class="notification-icon flex-shrink-0">
                <img
                  src="assets/images/icons/logo-notification.svg"
                  alt="Notification icon"
                  width="21"
                  height="21"
                />
              </div>
              <div class="notification-body flex-grow-1">
                <p class="notification-title text-sm mb-1" [class.has-link]="hasData(notification)">
                  {{ notification.body }}
                </p>
                <span class="notification-date text-sm">
                  {{ notification.created_at | date: 'd MMMM yyyy' }}
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
